import { BlockingError } from '../../lib/custom-errors'
import { Intl } from '../../localization'
import { PaymentError } from '../../typings/Payment'

const handlePaymentError = (error: string, setError: (key: string, error: string) => void, intl: Intl) => {
  const key = 'paymentError'
  switch (error) {
    case PaymentError.PAYMENT_ERROR_REQUEST_TIMEOUT:
      return setError(key, intl.paymentErrorRequestTimeout())
    case PaymentError.PAYMENT_ERROR_CANCELLED:
      throw new BlockingError('The payment was cancelled', intl.paymentErrorCancelled())
    case PaymentError.PAYMENT_ERROR_FAILED:
      return setError(key, intl.paymentErrorFailed())
    case PaymentError.PAYMENT_ERROR_ORDER_ABORTED:
      throw new BlockingError('The order was already aborted', intl.orderAbortedError())
    case PaymentError.PAYMENT_ERROR_STRIPE_SOURCE:
      return setError(key, intl.paymentErrorStripeSource())
    default:
      return setError(key, error)
  }
}

export default handlePaymentError
